<ng-container>
    <div>
        <app-icon-legend [thesaurusId]="thesaurusId"></app-icon-legend>
    </div>

    <div class="row explode-major-col-wrapper">
        <div *ngIf="isMajor || isExplode" class="explode-major-col-label">
            <span *ngIf="isExplode">Explode</span>
            <span *ngIf="isMajor">Major</span>
        </div>
    </div>
    <ngx-spinner 
        name="index-spinner"
        bdColor="rgba(51,51,51,0.8)"
        size="medium"
        color="#fff"
        type="ball-clip-rotate"
    >
        <p aria-live="polite" style="font-size: 20px; color: white">Loading...</p>
    </ngx-spinner>
    <div id="termsWrapper" tabindex="-1">
        {{'hierarchicalInstructionalText' | i18next}}
         <mat-tree #matTree [dataSource]="thesaurusDataSource" [childrenAccessor]="childrenAccessor" #tree class="thesaurus-tree">

        <mat-nested-tree-node #matNestedTreeNode *matTreeNodeDef="let node; when: hasChild">
           <div class="mat-tree-node">
                <button id="mat-tree-node-{{node.termOrdinal}}{{utilitiesService.getPathIdentifier(node.paths)}}" matTreeNodeToggle [attr.aria-label]="'toggle ' + node?.name" tabindex="0" class="plusMinus" (click)="handleNodeChange(tree?.isExpanded(node)??false, node)" (keydown.enter)="handleNodeChange(tree?.isExpanded(node)??false, node)">
                    <span *ngIf="!tree?.isExpanded(node)" class="expandIcon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="currentColor" class="bi bi-plus-square" viewBox="0 0 16 16">
                        <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
                        </svg>
                    </span>
                    <span *ngIf="tree?.isExpanded(node)" class="collapseIcon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="currentColor" class="bi bi-dash-square" viewBox="0 0 16 16">
                        <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"/>
                    </svg>
                    </span>

                </button>
                <div id="termName">
                    <app-thesaurus-entry #thesEntry [entry]="node" [isRoot]="isRootNode(node)" [notesId]="utilitiesService.getPathIdentifier(node.paths)" [collapsingNotesId]="utilitiesService.getPathIdentifier(node.paths)" [index]="node.id" [explode]="isExplode" [major]="isMajor && !isRootNode(node)" [linkable]="!isRootNode(node)"></app-thesaurus-entry>
                </div>
            </div>
            <div class="nested-node" [class.hideNode]="!tree.isExpanded(node)" role="group">
                <ng-container matTreeNodeOutlet>
                </ng-container>
            </div>
        </mat-nested-tree-node>

        <mat-tree-node *matTreeNodeDef="let node; when: isLeaf">
            <span class="leaf-node-spacer"></span>
            <div id="termName">
                <app-thesaurus-entry #thesEntry [entry]="node" [isRoot]="isRootNode(node)" [notesId]="utilitiesService.getPathIdentifier(node.paths)" [collapsingNotesId]="utilitiesService.getPathIdentifier(node.paths)" [index]="node.id" [explode]="isExplode" [major]="isMajor"></app-thesaurus-entry>
            </div>
        </mat-tree-node>
    </mat-tree>

    </div>
</ng-container>